export default {
    user: {},
    token: '',
}